import { Link } from "react-router-dom";
import { influencers } from "@/mocks/influencers";

export default function Influencers() {
  return (
    <section className="bg-background-100 py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">Creators</p>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              红人专区
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              美食探店、影视解读、生活记录、创意动画，头部红人新作第一时间追更。
            </p>
          </div>
          <Link to="/columns/red" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
            更多红人视频 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {influencers.map((p) => (
            <article key={p.id} className="group overflow-hidden rounded-2xl bg-background-50 ring-1 ring-inset ring-background-200 transition hover:ring-primary-300">
              <Link to="/columns/red" className="block">
                <div className="relative aspect-video w-full overflow-hidden">
                  <img
                    src={p.cover}
                    alt={`${p.name}的频道封面`}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute bottom-2 left-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
                    {p.category}
                  </span>
                </div>
              </Link>
              <div className="flex items-start gap-3 p-4">
                <img
                  src={p.avatar}
                  alt={`${p.name}的头像`}
                  className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-primary-200"
                />
                <div className="min-w-0">
                  <h3 className="truncate text-sm font-semibold text-foreground-950">{p.name}</h3>
                  <p className="truncate text-xs text-foreground-500">{p.handle}</p>
                  <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{p.intro}</p>
                  <p className="mt-1.5 flex items-center gap-1 text-xs font-medium text-primary-600">
                    <i className="ri-team-line" /> {p.followers} 粉丝
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}